import { networkAction } from "helpers/network/networkAction";

import {
  GET_LINKS,
  GET_LINK_BY_ID,
  DELETE_LINK,
  UPDATE_LINK,
  CREATE_LINK,
} from "constants/links";

import * as Api from "api";

export const getLinks = (filters) => async (dispatch) =>
  networkAction(dispatch, GET_LINKS, Api.getLinks, [filters]);

export const getLinkById = (id) => async (dispatch) =>
  networkAction(dispatch, GET_LINK_BY_ID, Api.getLinkById, [id]);

export const deleteLink = (id) => async (dispatch) =>
  networkAction(dispatch, DELETE_LINK, Api.deleteLink, [id]);

export const createLink = (body) => async (dispatch) =>
  networkAction(dispatch, CREATE_LINK, Api.createLink, [body]);

export const updateLink = (id, body) => async (dispatch) =>
  networkAction(dispatch, UPDATE_LINK, Api.updateLink, [id, body]);
